export default __webpack_public_path__ + "static/media/11-small.eb1188f5.png";